import { inject } from 'mobx-react';
import * as React from 'react';

import { ClientLogger } from 'bernie-client';
import { ContextStore, ExperimentStore, PageStore } from 'bernie-core';

import { evaluateAndLogExperiment } from 'stores/utils';

import { PropertyListingBadgeModel } from 'models';
import { RfrrPageNamespace } from 'constants/analytics';

import { UitkLayoutPosition } from 'uitk-react-layout-position';

import { fetchAndLogStatus } from 'utils/fetch-status-utils';

import { BadgeGenerator } from 'components/common/badge-generation';
import { Theme } from 'src/common/__generated__/api';
import * as ViewportListener from 'components/common/lazy/viewport-listener.js';

interface RenderBadgeProps {
  propertyListingBadgeModel: PropertyListingBadgeModel;
  travelAd: {
    impressionTrackingUrl: string;
  };
  pinnedDefaultListing?: boolean;
  rfrr?: String;
  page?: PageStore;
  context?: ContextStore;
  experiment?: ExperimentStore;
}

const travelAdImpressions = [];
let exposureLoggingFired = false;
export const PrimaryBadge: React.FunctionComponent<RenderBadgeProps> = inject(
  'page',
  'experiment',
  'context'
)(({ propertyListingBadgeModel, travelAd, pinnedDefaultListing, rfrr, page, experiment, context }) => {
  const badgeRef = React.useRef(null);
  const { primary } = { ...propertyListingBadgeModel };
  const { impressionTrackingUrl } = travelAd || {};

  const travelAdBadgeSeen = () => {
    if (!exposureLoggingFired) {
      exposureLoggingFired = true;
      evaluateAndLogExperiment('rename_travel_ad_badge', context, experiment, page);
    }
  };

  React.useEffect(() => {
    const isPropertyDetailsCarousel = rfrr && rfrr.includes(RfrrPageNamespace.Infosite);
    const badgeRefCurrent = badgeRef.current;
    if (badgeRefCurrent && primary.theme === Theme.SPONSORED && !isPropertyDetailsCarousel) {
      ViewportListener.subscribe(
        'window',
        badgeRefCurrent,
        {
          didEnter: () => travelAdBadgeSeen(),
        },
        { triggerOnce: true }
      );
    }
  }, [badgeRef]);

  if (typeof window !== 'undefined' && impressionTrackingUrl && !travelAdImpressions.includes(impressionTrackingUrl)) {
    travelAdImpressions.push(impressionTrackingUrl);
    fetchAndLogStatus(
      impressionTrackingUrl,
      ClientLogger.getLoggerWithIdentifier('pwa.component.title-badge'),
      'TRAVELAD_IMPRESSION_FAILURE',
      null
    );
  }

  const primaryIsSafe = primary && (primary.text || primary.icon || primary.mark);

  const position = pinnedDefaultListing
    ? { top: 'twelve' as 'twelve', left: 'three' as 'three', zindex: 'layer3' as 'layer3' }
    : { top: 'one' as 'one', left: 'three' as 'three', zindex: 'layer3' as 'layer3' };

  return (
    <React.Fragment>
      {primaryIsSafe && (
        <UitkLayoutPosition type="absolute" position={position}>
          <div ref={badgeRef}>
            <BadgeGenerator badge={primary} badgeClasses="all-t-margin-two" />
          </div>
        </UitkLayoutPosition>
      )}
    </React.Fragment>
  );
});

PrimaryBadge.displayName = 'PrimaryBadge';
